/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod/v4";

export const upsertContactPathParamsSchema = z.object({
    "id": z.string().describe("Contact identifier")
    })

export const upsertContactQueryParamsSchema = z.object({
    "idType": z.optional(z.enum(["internal", "external"]))
    }).optional()

export const upsertContactHeaderParamsSchema = z.object({
    "x-radar-user-id": z.optional(z.string().describe("Contact owner id — required when authenticating with the service secret instead of a bearer token"))
    }).optional()

/**
 * @description Contact updated
 */
export const upsertContact200Schema = z.object({
    "id": z.string(),
"userId": z.string(),
"externalId": z.nullable(z.string()),
"name": z.nullable(z.string()),
"title": z.nullable(z.string()),
"email": z.nullable(z.string()),
"phone": z.nullable(z.string()),
"company": z.nullable(z.string()),
"location": z.nullable(z.string()),
"socialMedia": z.nullable(z.object({
    
    }).catchall(z.string())),
"createdAt": z.iso.datetime(),
"updatedAt": z.iso.datetime()
    })

/**
 * @description Contact created
 */
export const upsertContact201Schema = z.object({
    "id": z.string(),
"userId": z.string(),
"externalId": z.nullable(z.string()),
"name": z.nullable(z.string()),
"title": z.nullable(z.string()),
"email": z.nullable(z.string()),
"phone": z.nullable(z.string()),
"company": z.nullable(z.string()),
"location": z.nullable(z.string()),
"socialMedia": z.nullable(z.object({
    
    }).catchall(z.string())),
"createdAt": z.iso.datetime(),
"updatedAt": z.iso.datetime()
    })

/**
 * @description Invalid body
 */
export const upsertContact400Schema = z.any()

/**
 * @description Contact limit reached (body.code = \"contact-limit-reached\")
 */
export const upsertContact403Schema = z.any()

export const upsertContactMutationRequestSchema = z.object({
    "name": z.optional(z.string()),
"title": z.optional(z.string()),
"email": z.optional(z.string()),
"phone": z.optional(z.string()),
"company": z.optional(z.string()),
"location": z.optional(z.string()),
"socialMedia": z.optional(z.object({
    
    }).catchall(z.string()))
    })

export const upsertContactMutationResponseSchema = z.union([z.lazy(() => upsertContact200Schema), z.lazy(() => upsertContact201Schema)])